import { render } from "./RestInterfaceList.vue?vue&type=template&id=3f2ec32e&scoped=true"
import script from "./RestInterfaceList.vue?vue&type=script&lang=js"
export * from "./RestInterfaceList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2ec32e"]])

export default __exports__